
webpack.register(
    'components/dropdown/dropdown-container/dropdown-container',
    function() {
        return import('components/dropdown/dropdown-container/dropdown-container');
    },
    true
);
webpack.register(
    'components/dropdown/dropdown-link/dropdown-link',
    function() {
        return import('components/dropdown/dropdown-link/dropdown-link');
    },
    true
);